import PropTypes from "prop-types";
import Snackbar, { SEVERITY } from "../Snackbar/Snackbar";
import { useAppSelector } from "../../../app/hooks";
import { selectMessage } from "../../../features/dialog/dialogSelectors";
import { SEVERITY as MESSAGE_SEVERITY } from "../../../features/dialog/dataTypes";

const SnackbarMessage = ({ onReset }: { onReset: () => void }) => {
  const message = useAppSelector(selectMessage);

  return (
    <Snackbar
      severity={message?.type === MESSAGE_SEVERITY.ERROR ? SEVERITY.ERROR : SEVERITY.SUCCESS}
      onClose={onReset}
      message={message?.value}
    />
  );
};

SnackbarMessage.propTypes = {
  onReset: PropTypes.func.isRequired,
};

export default SnackbarMessage;
